<div class="pd-api">
  <div class="d-flex justify-content-between mb-3">
    <div>
      <h6 class="mb-0">Exposition API par champ</h6>
      <p class="mb-0 text-muted small">Contrôle fin pour intégrations et webhooks.</p>
    </div>
    <button
      type="button"
      class="btn rippleEffect"
      style="background: rgba(19, 74, 211, 1); color: rgba(255, 255, 255, 1)"
      (click)="save()"
    >
      Enregistrer
    </button>
  </div>

  <div class="pd-api__table-shell mb-2">
    <div class="table-responsive">
      <table class="table table-hover mb-0 pd-api__table">
        <thead class="custom-header">
          <tr>
            <th>Champ</th>
            <th>Code</th>
            <th>Exposé API</th>
            <th>Nom technique API</th>
            <th>Lecture seule API</th>
            <th>Création</th>
            <th>Mise à jour</th>
            <th>Webhook</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of champs; trackBy: trackById">
            <td>{{ c.libelle }}</td>
            <td><code class="small">{{ c.code }}</code></td>
            <td>
              <div class="custom-control custom-checkbox mb-0">
                <input type="checkbox" class="custom-control-input" [id]="'api-ex-' + c.id" [(ngModel)]="c.api.exposeApi" />
                <label class="custom-control-label" [for]="'api-ex-' + c.id"></label>
              </div>
            </td>
            <td><input class="form-control form-control-sm" [(ngModel)]="c.api.nomTechniqueApi" /></td>
            <td>
              <div class="custom-control custom-checkbox mb-0">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  [id]="'api-ls-' + c.id"
                  [(ngModel)]="c.api.lectureSeuleApi"
                />
                <label class="custom-control-label" [for]="'api-ls-' + c.id"></label>
              </div>
            </td>
            <td>
              <div class="custom-control custom-checkbox mb-0">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  [id]="'api-cr-' + c.id"
                  [(ngModel)]="c.api.autoriseCreation"
                />
                <label class="custom-control-label" [for]="'api-cr-' + c.id"></label>
              </div>
            </td>
            <td>
              <div class="custom-control custom-checkbox mb-0">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  [id]="'api-maj-' + c.id"
                  [(ngModel)]="c.api.autoriseMiseAJour"
                />
                <label class="custom-control-label" [for]="'api-maj-' + c.id"></label>
              </div>
            </td>
            <td>
              <div class="custom-control custom-checkbox mb-0">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  [id]="'api-wh-' + c.id"
                  [(ngModel)]="c.api.visibleWebhook"
                />
                <label class="custom-control-label" [for]="'api-wh-' + c.id"></label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <p *ngIf="!champs.length" class="text-muted small">Aucun champ — créez-en dans l’onglet Champs.</p>
</div>
